import { EditorState } from "@tiptap/pm/state";
import { Node } from "@tiptap/pm/model";

export const doesPromptScreenContainTable = (
  editorState: EditorState,
): boolean => {
  return !!findTableNodeFromEditorState(editorState);
};

export const findColumnCountForTable = (editorState: EditorState): number => {
  const tableNode = findTableNodeFromEditorState(editorState);
  return tableNode?.child(0).childCount || 0;
};

const findTableNodeFromEditorState = (
  editorState: EditorState,
): Node | undefined => {
  const { doc } = editorState;
  const nodes: Node[] = [];
  doc.descendants((node) => {
    nodes.push(node);
  });
  return nodes.find((node) => node.type.name === "table");
};
